import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OfferCardContainerDesktop } from './OfferCardContainerDesktop';
import { OfferCardContentDesktop } from './OfferCardContentDesktop';
import { OfferCardFooterDesktop } from './OfferCardFooterDesktop';
import { OfferCardHeaderDesktop } from './OfferCardHeaderDesktop';
import { OfferCardMostPopularLabel } from './OfferCardMostPopularLabel';
export function OfferCardDesktop({ offerCard, }) {
    const { isMostPopular } = offerCard;
    return (_jsxs(OfferCardContainerDesktop, { isMostPopular: isMostPopular, children: [isMostPopular && _jsx(OfferCardMostPopularLabel, {}), _jsx(OfferCardHeaderDesktop, {}), _jsx(OfferCardContentDesktop, {}), _jsx(OfferCardFooterDesktop, {})] }));
}
